import { useEffect, useRef } from 'react'

export function useInterval(callback: Function, delay: number) {
  const savedCallback = useRef()

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback as any
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    function tick() {
      ;(savedCallback as any).current()
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}
